import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AttioLinkedService } from 'app/model/linkedservice/attio.linkedservice';
import { TabularTypeDataset } from 'app/model/dataset/tabular-type.dataset';

@Metamodel.model({
    name: 'AttioObject',
    display: [],
    constraints: {
        linkedService: {
            model: AttioLinkedService.MODEL
        }
    }
})
export class AttioObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
}
